import posthog from 'posthog-js'

import { TAB_COUNT_THRESHOLDS } from '@/config/constants'
import { ENV } from '@/config/env'

export type TabCountDirection = 'up' | 'down'

export interface TabCountCrossing {
  threshold: number
  direction: TabCountDirection
}

/** Thresholds crossed between `previous` and `current`, one entry per crossing. */
export function getTabCountCrossings(
  previous: number,
  current: number
): TabCountCrossing[] {
  if (previous === current) return []
  const crossings: TabCountCrossing[] = []
  for (const threshold of TAB_COUNT_THRESHOLDS) {
    if (previous < threshold && current >= threshold) {
      crossings.push({ threshold, direction: 'up' })
    } else if (previous >= threshold && current < threshold) {
      crossings.push({ threshold, direction: 'down' })
    }
  }
  return crossings
}

// PostHog is gated off in dev — mirror to console.warn so the event is visible locally.
export function emitTabCountCrossings(args: {
  previous: number
  current: number
  routes: string[]
}) {
  const crossings = getTabCountCrossings(args.previous, args.current)
  for (const { threshold, direction } of crossings) {
    const payload = {
      threshold,
      direction,
      count: args.current,
      routes: args.routes,
    }
    posthog.capture('tab_count_threshold', payload)
    if (ENV === 'development') {
      console.warn('[tab-activity] tab_count_threshold', payload)
    }
  }
}
